module.exports = __webpack_public_path__ + "img/icon-cart.a19141d2.svg";